<div class="background-gradient white-color">
  <div class="container special-register-bootstrap-container">
    <div class="row">
      <div class="col-12">
        <div class="special-register-header">
          <img src="https://springbot-assets.s3.us-east-1.amazonaws.com/images/sb-logo-reverse.png" alt="SendAI Logo" class="sendai-logo" />
          <div class="headline white-color">We Pre-Selected Everything For <span class="highlight">{{ data?.storeUrl }}</span></div>
          <div class="subline">4 minutes → 30 seconds</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="open-rate-banner">
          <span class="open-rate-green">All emails</span> generated <span class="open-rate-gold">+24% higher open rates</span>
        </div>
      </div>
    </div>

    <div class="row g-4 special-register-cards-bootstrap">
      <div class="col-12 col-md-6 p-2">
        <div class="info-card domain w-100">
          <div class="icon"><i class="fa fa-check-circle"></i></div>
          <div class="label">Domain Analyzed</div>
          <div class="value domain-url">{{ data?.storeUrl }}</div>
        </div>
      </div>
      <div class="col-12 col-md-6 p-2">
        <div class="info-card tone w-100">
          <div class="icon"><i class="fa fa-lightbulb"></i></div>
          <div class="label">Tone Selected</div>
          <div class="value tone-value">{{ data?.tone }}</div>
        </div>
      </div>
      <div class="col-12 col-md-6 p-2">
        <div class="info-card style w-100">
          <div class="icon"><i class="fa fa-palette"></i></div>
          <div class="label">Style Chosen</div>
          <div class="value style-value">{{ data?.style }}</div>
        </div>
      </div>
      <div class="col-12 col-md-6 p-2">
        <div class="info-card promo w-100">
          <div class="icon"><i class="fa fa-tag"></i></div>
          <div class="label">Promo Message</div>
          <div class="value promo-value">{{ data?.context }}</div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8">
        <div class="special-register-form-section">
          <div class="form-title">Ready to Generate Yours?</div>
          <div class="form-subtitle">
            Create account for <b>{{ data?.email }}</b>
            <span class="not-you-link-inline"><a href="/register">Not you?</a></span>
          </div>
          <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="form">
            <div class="form-group">
              <input type="password" formControlName="password" placeholder="Choose password to generate & save" required />
              <div class="error" *ngIf="form.get('password').touched && form.get('password').invalid">
                Password must be at least 8 characters.
              </div>
            </div>
            
            <div class="form-group">
              <div class="checkbox-container">
                <input type="checkbox" formControlName="agreeToTerms" id="agreeToTermsSpecial" />
                <label for="agreeToTermsSpecial">
                  I agree to Springbot's <a href="https://springbot.com/terms-of-use/" target="_blank">Terms of Use</a> and <a href="https://springbot.com/privacy-policy-2/" target="_blank">Privacy Policy</a>.
                </label>
              </div>
              <div class="error" *ngIf="form.get('agreeToTerms').touched && form.get('agreeToTerms').invalid">
                You must agree to the Terms of Use and Privacy Policy to continue.
              </div>
            </div>
            
            <div class="error" *ngIf="error" [innerHTML]="error"></div>
            <button type="submit" [disabled]="loading || form.invalid">
              {{ loading ? 'Generating...' : 'Generate & Save My Email' }}
            </button>
            <div class="footer-note">30 seconds • Ready to send</div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div> 